var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(
      this.$route.name == 'home' ||
        this.$route.name == 'division' ||
        this.$route.name == 'product'
    )?_c('Jumbotron',{attrs:{"title":this.$route.path === '/' ? 'RPL - GDC' : this.$route.name}}):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }